import React, { useState } from "react";
import ImmoHeader from "../immobilier/componnents/ImmoHeader";
import Container from "../../components/Container/Container";
import CustomButton from "../../components/commons/CustomBtn";
import CollaboratorsList from "./components/CollaboratorsList";

const BackOffice = () => {
  const [backOfficeView, setBackOfficeView] = useState("membres");
  const [usersfilter, setusersfilter] = useState("");
  return (
    <Container>
      <div className="d-flex gap10">
        <CustomButton
          onClick={() => setBackOfficeView("membres")}
          label="Membres"
          contentLengthClass={`${backOfficeView === "membres"
            ? "regular fs11 pink "
            : "regular fs11 white"
            } `}
          buttonClass={`${backOfficeView === "membres"
            ? "bg-white radiusTop5 px-20 py-10 "
            : "bg-pink radiusTop5 px-20 py-10 white"
            } `}
          labelClass={`${backOfficeView === "membres"
            ? "pink fs16 semibold text-capitalize text-start"
            : "white fs16 semibold text-capitalize text-start"
            }`}
        />
        {/*  <CustomButton
          onClick={() => setBackOfficeView("permissions")}
          label="Permissions"
          contentLength1=""
          contentLength2=""
          contentType2=""
          contentLengthClass={`${
            backOfficeView === "permissions"
              ? "regular fs11 pink "
              : "regular fs11 white"
          } `}
          buttonClass={`${
            backOfficeView === "permissions"
              ? "bg-white radiusTop5 px-20 py-10 "
              : "bg-pink radiusTop5 px-20 py-10 white"
          } `}
          labelClass={`${
            backOfficeView === "permissions"
              ? "pink fs16 semibold text-capitalize text-start"
              : "white fs16 semibold text-capitalize text-start"
          }`}
        /> */}
      </div>

      {backOfficeView === "membres" && (
        <ImmoHeader
          activeView={backOfficeView}
          setActiveView={(view) => setBackOfficeView(view)}
          carte={false}
          lots={false}
          programmes={false}
          filterInput={usersfilter}
          setFilterInput={setusersfilter}
          addSecteur={true}
          backOffice={true}
          filterBtn={false}
          hideSearch={true}
        />
      )}
      {/*  {backOfficeView === "permissions" && (
        <BackOfficeHeader
          setPermissionsView={setPermissionsView}
          permissionsView={permissionsView}
        />
      )} */}
      {backOfficeView === "membres" && (
        <CollaboratorsList filterInput={usersfilter} />
      )}
      {/*  {backOfficeView === "permissions" && (
        <Permissions permissionsView={permissionsView} />
      )} */}
    </Container>
  );
};

export default BackOffice;
